import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="rpe" data-testid="error-boundary">
          <div className="content">
            <div className="card card__pad" style={{ maxWidth: 640, margin: "48px auto" }}>
              <div className="card__kicker">Something went wrong</div>
              <p style={{ marginBottom: 16 }}>
                {this.state.error?.message ?? "An unexpected error occurred."}
              </p>
              <button className="btn btn--primary" onClick={() => this.setState({ hasError: false, error: null })}>
                Try again
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
